import Checkbox from "components/Common/Form/Checkbox";
import FormInput from "components/Common/Form/Input/FormInput";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { DspmApplicationInfoType } from "src/service/types/pay.type";

const storageOptions: DspmApplicationInfoType[] = [
  { applicationName: "Google workspace", userCount: 1 },
  { applicationName: "Slack", userCount: 1 },
];
const SelectDspmApplicationInfoList = () => {
  const [selectedApplicationInfo, setSelectedApplicationInfo] = useState<
    DspmApplicationInfoType[]
  >([]);
  const {
    setValue,
    register,
    formState: { errors },
    control,
  } = useFormContext();
  const applicationNames = storageOptions.map((o) => o.applicationName);
  const watchNames = [
    ...applicationNames,
    ...applicationNames.map((n) => `userCount_${n}`),
  ];
  const watched = useWatch({ control, name: watchNames });
  const applicationCheckedMap = applicationNames.reduce((acc, name, idx) => {
    acc[name] = Boolean(watched?.[idx]);
    return acc;
  }, {} as Record<string, boolean>);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCheckboxChange = (checked: boolean, applicationName: string) => {
    setSelectedApplicationInfo((prev) => {
      if (checked) {
        return [...prev, { applicationName: applicationName, userCount: 1 }];
      }
      return prev.filter((item) => item.applicationName !== applicationName);
    });
  };
  // 사용자 수 변경 핸들러
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleUserCountChange = (
    applicationName: string,
    key: keyof DspmApplicationInfoType,
    value: number | null
  ) => {
    if (value === null) return;

    setSelectedApplicationInfo((prev) =>
      prev.map((item) =>
        item.applicationName === applicationName
          ? { ...item, [key]: value }
          : item
      )
    );
  };
  void handleCheckboxChange;
  void handleUserCountChange;
  useEffect(() => {
    const applicationNamesLocal = storageOptions.map((o) => o.applicationName);
    const numApplications = applicationNamesLocal.length;
    const startUserCountIndex = numApplications;

    const checkedByIndex = Array.from({ length: numApplications }, (_, idx) =>
      Boolean(watched?.[idx])
    );
    const userCountByIndex = Array.from(
      { length: numApplications },
      (_, idx) => {
        const raw = watched?.[startUserCountIndex + idx] as
          | number
          | string
          | undefined;
        const num = Number(raw);
        return Number.isFinite(num) ? (num as number) : undefined;
      }
    );

    const newSelected = storageOptions
      .map((o, idx) => ({ o, idx }))
      .filter(({ idx }) => checkedByIndex[idx])
      .map(({ o, idx }) => ({
        applicationName: o.applicationName,
        userCount: userCountByIndex[idx] ?? 1,
      }));

    const isSame =
      selectedApplicationInfo.length === newSelected.length &&
      selectedApplicationInfo.every((item, i) => {
        const other = newSelected[i];
        return (
          item.applicationName === other.applicationName &&
          item.userCount === other.userCount
        );
      });

    if (!isSame) {
      setSelectedApplicationInfo(newSelected);
      setValue("dspmApplicationInfo", newSelected);
    }
  }, [watched, setValue, selectedApplicationInfo]);
  return (
    <div>
      {storageOptions.map((option) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const isChecked = selectedApplicationInfo.some(
          (item) => item.applicationName === option.applicationName
        );

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const currentData = selectedApplicationInfo.find(
          (item) => item.applicationName === option.applicationName
        );
        void isChecked;
        void currentData;

        return (
          <div
            key={option.applicationName}
            style={{ marginBottom: "10px" }}
            // align="middle"
            // gutter={16}
            // wrap={false}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {/* 체크박스 */}
              <div
                style={{
                  width: "235px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  children={
                    <label htmlFor={option.applicationName}>
                      {option.applicationName}
                    </label>
                  }
                  name={option.applicationName}
                  register={register}
                  errors={errors}
                  checked={
                    applicationCheckedMap[option.applicationName] || false
                  }
                ></Checkbox>
              </div>

              {/* 사용자 수 입력란 */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "30%",
                }}
              >
                <FormInput
                  name={`userCount_${option.applicationName}`}
                  type="number"
                  min={1}
                  disabled={!applicationCheckedMap[option.applicationName]}
                  register={register}
                  errors={errors}
                />
                <span>명</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectDspmApplicationInfoList;
